const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/

const formatDate = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

const getLastDayOfMonth = (year, monthIndex) => {
  return new Date(year, monthIndex + 1, 0).getDate()
}

const addCalendarMonths = (date, monthCount) => {
  const targetYear = date.getFullYear()
  const targetMonth = date.getMonth() + monthCount
  const targetLastDay = getLastDayOfMonth(targetYear, targetMonth)
  if (date.getDate() > targetLastDay) {
    return new Date(targetYear, targetMonth + 1, 1)
  }

  return new Date(targetYear, targetMonth, date.getDate())
}

export function calculateServiceEndByMonthlyPeriods(startDate, periodCount) {
  if (!DATE_PATTERN.test(startDate || '')) return ''

  const periods = Number(periodCount)
  if (!Number.isInteger(periods) || periods < 1) return ''

  const start = new Date(`${startDate}T00:00:00`)
  if (Number.isNaN(start.getTime())) return ''

  const end = addCalendarMonths(start, periods)
  end.setDate(end.getDate() - 1)
  return formatDate(end)
}
